<template>
 <div class="step2"  v-bind = "{...$attrs}" v-loading="loading">
<!--  <div class="topFlex" style="margin-bottom: 10px;padding-right: 0">-->
<!--    <div class="showzz" @click="showAll()"></div>-->
<!--    <el-checkbox v-model="checked" @submit.native.prevent>显示全部表头</el-checkbox>-->
<!--  </div>-->
     <div class="showAll" >
       <div class="showzz" @click="showAll()"></div>
       <el-checkbox v-model="checked" @submit.native.prevent>显示全部表头</el-checkbox>
     </div>
        <div class="tableCon"  style="width: 100%;">
        <el-table
          border
          resizable
          auto-resize
          show-footer
          width="100%"
          max-height="300px"
          :data="checked?tableData:filteredTableData"
        >
         <template v-slot:empty>
              <span>
                <p style="text-align: center;">已全部匹配</p>
              </span>
         </template>
        <el-table-column type="index" :width="50"  label="序号"></el-table-column>
        <el-table-column prop="columnName" label="Excel表头字段"></el-table-column>
        <el-table-column prop="name" id="selects" label="系统字段">
        <template  slot-scope="scope"><!--v-slot="{ row }" slot-scope="scope"-->
          <el-select
            v-if="checked"
            clearable
            no-match-text=""
            :ref="'select'+scope.$index"
            @change="changeData($event,scope.$index)"
            v-model="tableData[scope.$index].sys"
            filterable="true"
            @focus="loadOptions(scope.$index,tableData[scope.$index].sys)"
            :class="{nodata:checked?!tableData[scope.$index].sys:!filteredTableData[scope.$index].sys}"
            placeholder="未匹配"
            popper-append-to-body="false"
          >
            <el-option-group
              v-for="group in options[scope.$index]"
              :key="group.id"
              :label="group.name">
              <el-option
                v-for="item in group.wageItemList"
                :key="item.id"
                :label="item.itemNameCh"
                :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
          <el-select
             v-else
             clearable no-match-text=""
             :ref="'select'+scope.$index"
             @change="changeData($event,scope.$index)"
             v-model="filteredTableData[scope.$index].sys"
             filterable="true"
             @focus="loadOptions(scope.$index,tableData[scope.$index].sys)"
             :class="{nodata:checked?!tableData[scope.$index].sys:!filteredTableData[scope.$index].sys}"
             placeholder="未匹配"
             popper-append-to-body="false" >
            <el-option-group
              v-for="group in options[scope.$index]"
              :key="group.id"
              :label="group.name">
              <el-option
                v-for="item in group.wageItemList"
                :key="item.id"
                :label="item.itemNameCh"
                :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
        </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="footer">
      <div>温馨提示：</div>
      <div>
        <p>1.当Excel导入的信息项目与系统薪资项名称完全一致时，系统自动匹配</p>
        <p>2.未匹配的薪资项下的数据将不予导入</p>
        <p>2.系统自动记录对应关系，如导入模板未发生变化，无需重复匹配</p>
      </div>
    </div>
    <div style="margin-top: 8px;padding-bottom: 24px;text-align:center;">
      <el-button type="primary" @click="upStep()">上一步</el-button>
      <el-button type="primary" @click="next()">下一步</el-button>
    </div>
</div>

</template>

<script>
  import {uploadStepTwo} from "@/api/wage/batchTemplate";
 import { mapGetters} from 'vuex';
  var loadingMatch;
  export default {
    name: "step2",
    props: {
      //父组件下拉框传递给子组件的id声明
      templateId:{
        type: String,
        default: '',
      },
      payGroupId:{
        type: String,
        default: '',
      },
      orgId:{
        type: String,
        default: '',
      },
       step: {
       	type: String,
       	default: '',
       },
      operation: {
       	type: String,
       	default: '',
       },
      sheetNameParam: {
       	type: String,
       	default: '',
       },
      step2Info: {
          type: Object,
          default:()=> ({}),
      },
      step4Info: {
       	type: Object,
       	default:()=> ({}),
       },
      step3Info: {
       	type: Object,
       	default: ()=>({}),
       },
      batchInfoDetail:{//父页面传入的批次信息
        type: Object,
        default: ()=>({}),
      },
      formInline:{//父页面传入的批次信息
        type: Object,
        default: ()=>({}),
      },
      headerRow:{
        type: String,
        default: ""
      }
    },
    data() {
      return {
        loading:false,
				checked:false,
        tableHeight:'300px',
        filteredTableData: [],//未匹配
        // batchId: this.step2Info.headerInfo.batchId,
        // cusName: this.step2Info.cusName, //上传第一步选择的客户
        batchId: '',
        fileId: '',
        tableData: [], //表格数据
        tableDataCopy:null,
        filteredTableDataCopy:null,
        options:  [], //候选表头
        optionsData:null,//当前条option
        optionsCopy:[],//中转
        optionsTotal: [], //候选表头
        optionsBase: [], //基本表头
        batchInfo: [],
        zancunOptions:{},// 暂存更改项
        zancunId:"",
				ref:'',
      };
    },
    computed:{
        ...mapGetters([
            'step2Info'
        ]),
        tableData1(){
            if(!this.checked){
                return	this.tableData//.slice(0,9);
            }else{
                return	this.filteredTableData
            }
        }
    },
    created(){
        console.log("this.step2Info==6-12222==",this.step2Info);
        this.filteredTableData = this.tableData.filter(function(data,index) {
            if (!data.sys &&data.sys !== 0) {
                return data;
            }
        });
        this._init();
        this.$set(this,"tableDataCopy",JSON.parse(JSON.stringify(this.tableData)));
        this.$set(this,"filteredTableDataCopy",JSON.parse(JSON.stringify(this.filteredTableData)));

        //若果不存在未配置的数据,直接出发下一步操作
        // if(this.filteredTableData.length==0){
        //   this.next();
        // }
    },
    watch: {

    },
		mounted(){
			document.getElementsByClassName('main')[0].addEventListener('scroll',()=>{
				if(this.ref){
					this.$refs[this.ref].blur();
					this.ref = '';
				}
			});
			document.getElementsByClassName('el-table__body-wrapper')[0].addEventListener('scroll',()=>{
				if(this.ref){
					this.$refs[this.ref].blur();
					this.ref = '';
				}
			});
		},
    methods: {
			onfocus(ref){
				this.ref = ref;
			},
      _init(){
			   const that = this;
         this.fileId = this.step2Info.headerInfo.fileId;
         this.tableData = this.step2Info.headerInfo.headerList;
         this.options = this.step2Info.headerInfo.templateItemList;
         this.optionsTotal = this.step2Info.headerInfo.templateItemList; //候选表头
         this.batchInfo = this.step2Info.batchInfo;
         this.filteredTableData = this.tableData.filter(function(data,index) {
            if (!data.sys) {
                return data;
            }
         });
        // 获取到每一条的options
        console.log(this.optionsTotal.length)
        const len1 = this.optionsTotal.length;
        for(var i = 0;i < len1;i++){
            if(this.optionsTotal[i].wageItemList){
                var len2 = this.optionsTotal[i].wageItemList.length;
                console.log("optionsTotal[]==6-12222222=="+i+"==",this.optionsTotal[i]);
                for(var j = 0;j < len2;j++){
                    this.optionsCopy.push({pInx:i,cInx:j,gid:this.optionsTotal[i].id,name:this.optionsTotal[i].name,id:this.optionsTotal[i].wageItemList[j].id,itemNameCh:this.optionsTotal[i].wageItemList[j].itemNameCh})
                }
            }
        }
          // 删掉已匹配，获取基本options
          const optionsTotal = JSON.parse(JSON.stringify(this.optionsTotal))
          const sysTableData = this.tableData.filter(function(data,index) {
              if (data.sys||data.sys === 0) {
                  return data;
              }
          });
          for(var i = 0;i < sysTableData.length; i++){
              // 如果sys存在于copy,删除
              for(var j = 0;j < this.optionsCopy.length;j++){
                  if( sysTableData[i].sys == this.optionsCopy[j].id){
                      optionsTotal[this.optionsCopy[j].pInx].wageItemList[this.optionsCopy[j].cInx] = null
                      break;
                  }
              }
          }
          // 添加index
          const optionLen = optionsTotal.length;
          for(var i = 0;i < optionLen;i++){
              if(optionsTotal[i].wageItemList){
                  for(var j = 0;j < optionsTotal[i].wageItemList.length;j++){
                      if(optionsTotal[i].wageItemList[j]){
                          optionsTotal[i].wageItemList[j].pInx = i;
                          optionsTotal[i].wageItemList[j].cInx = j;
                      }
                  }
              }
          }
          optionsTotal.forEach((item) => {
              if(item.wageItemList){
                  item.wageItemList = item.wageItemList.filter((data) => {
                      return data != null
                  })
              }
          })
          console.log(optionsTotal,"optionsTotal")
          this.$set(this,"optionsBase",optionsTotal)
          console.log("6-12---this.tableData====",this.tableData)
          console.log("6-12---this.filteredTableData====",this.filteredTableData)
      },
      showAll(){
          loadingMatch = this.$loading({
              target:".matchTable",
              spinner: 'el-icon-loading',
          });
          setTimeout(() => {
              this.checked = !this.checked;
              this.changeCheck(this.checked);
          }, 100);
      },
      changeCheck:function(val){
			    debugger
          const that =this;
          // 不选中时更新未匹配列表
          if(!val && val !== 0){
              this.filteredTableData = this.tableData.filter(function(data,index) {
                  if (!data.sys && data.sys !== 0) {
                      return data;
                  }
              });
              this.filteredTableData = this.filteredTableData.filter(function(data,index) {
                  if (!data.sys&& data.sys !== 0) {
                      data.inx = index
                      return data;
                  }
              });
              this.$nextTick(() => {
                  loadingMatch.close();
                  this.$set(this.zancunOptions,"copy",JSON.parse(JSON.stringify(this.filteredTableData)))
              })
          }else{
              // 给option赋当前值，使显示正常
              this.optionsData = this.tableData.forEach(function(data,index) {
                  const sys = data.sys;
                  if (sys || sys === 0) {
                      const option ={};
                      that.optionsCopy.findIndex(function(value,index){
                          if(value.id == sys){
                              option.id = value.gid;
                              option.name = value.name;
                              option.wageItemList = [];
                              option.wageItemList[0] = {};
                              option.wageItemList[0].id = sys;
                              option.wageItemList[0].itemNameCh = value.itemNameCh;
                          }
                      })
                      console.log("option555555555555555555555555555",option)
                      that.$set(that.options,index,[option])
                  }
              });
              this.$nextTick(() => {
                  loadingMatch.close();
                  this.$set(this.zancunOptions,"copy",JSON.parse(JSON.stringify(this.tableData)));
              })

          }
      },
      loadOptions(index,id){
          // 暂存id，用于切换后增加option
          this.zancunId = id;
          const that =this;
          this.$set(this.options,index,[])
          // 增加更改项
          if(this.zancunOptions.addp&&this.zancunOptions.addp >= 0){
              let addc = this.zancunOptions.addc;
              let hascInx = this.optionsBase[this.zancunOptions.addp].wageItemList.findIndex(function(item,index){
                  return item.cInx == addc;
              })
              if(hascInx < 0){
                  this.optionsBase[this.zancunOptions.addp].wageItemList.push({id:this.optionsTotal[this.zancunOptions.addp].wageItemList[this.zancunOptions.addc].id,
                      itemNameCh:this.optionsTotal[this.zancunOptions.addp].wageItemList[this.zancunOptions.addc].itemNameCh,
                      pInx:this.zancunOptions.addp,
                      cInx:this.zancunOptions.addc,
                  });
              }

              this.$set(this.zancunOptions,"addp","")
              this.$set(this.zancunOptions,"addc","")
          }
          // 删除更改项
          if(this.zancunOptions.del||this.zancunOptions.del === 0){
              const del = this.zancunOptions.del;
              let cInx = this.optionsCopy[this.zancunOptions.del].cInx;
              var delItem = this.optionsBase[this.optionsCopy[this.zancunOptions.del].pInx].wageItemList.findIndex(function(item,index){
                  return item.cInx == cInx;
              })
              this.optionsBase[this.optionsCopy[this.zancunOptions.del].pInx].wageItemList.splice(delItem,1);
              this.$set(this.zancunOptions,"del","");
              this.$set(this.zancunOptions,"cInx","");
          }

          if(!id&&id !== 0){
              this.$set(this.options,index,this.optionsBase);
          }else{
              // 将数据恢复为只有一条
              let only1 = this.optionsCopy.findIndex(function(item,i){
                  return item.id == id;
              })

              const option ={};
              option.id = this.optionsCopy[only1].gid;
              option.name =  this.optionsCopy[only1].name;
              option.wageItemList = [];
              option.wageItemList[0] = {};
              option.wageItemList[0].id =  this.optionsCopy[only1].id;
              option.wageItemList[0].itemNameCh =  this.optionsCopy[only1].itemNameCh;
              option.wageItemList[0].pInx = this.optionsCopy[only1].pInx;
              option.wageItemList[0].cInx = this.optionsCopy[only1].cInx;
              this.$set(this.options,index,[option])
              const only = JSON.parse(JSON.stringify(that.options[index][0].wageItemList[0]));
              const gid = JSON.parse(JSON.stringify(that.options[index][0].id));

              let add = this.optionsBase.findIndex(function(item,index){
                  return item.id == gid
              })
              this.$set(this.options,index,JSON.parse(JSON.stringify(this.optionsBase)));

              this.options[index][add].wageItemList.push(only)
              // 排序
              this.options[index][add].wageItemList.sort(this.compare("cInx"));
          }

          const newOptions = this.options[index].filter(function(data,index) {
              if (data.wageItemList&&data.wageItemList.length > 0) {
                  return data;
              }
          });
          this.$set(this.options,index,newOptions);
          this.$forceUpdate()
      },
        changeData(val,index){
            const that =this;
            // 拿到新的id,如果copy的index里没有值,说明未匹配。如果有,应该删掉新的id，增加copy里的id
            // 如果原来未匹配，直接从基本options里删掉这项，如果已匹配，删一个增加一个，遍历已有基本值的options，删增
            const sys = this.zancunId;
            // 如何拿到之前的值，因为有可能一开始没有，后来有了
            if(sys||sys === 0){
                // 新增
                var addItem = this.optionsCopy.findIndex(function(item,index){
                    return item.id == sys;
                })
                this.$set(this.zancunOptions,"index",index)
                this.$set(this.zancunOptions,"addp",this.optionsCopy[addItem].pInx)
                this.$set(this.zancunOptions,"addc",this.optionsCopy[addItem].cInx)
            }
            if(val||val === 0){
                // 删除
                var delOption = this.optionsCopy.findIndex(function(item,index){
                    return item.id == val;
                })
                let cInx = this.optionsBase[this.optionsCopy[delOption].pInx].wageItemList.findIndex(function(item,index){
                    return item.id == val;
                })
                this.$set(this.zancunOptions,"del",delOption);
                this.$set(this.zancunOptions,"cInx",cInx);
            }else{
                // 如果val为空，判断为清空,增加被删掉的option
                const clearId = this.zancunOptions.copy[index].sys;
                var addOption = this.optionsCopy.findIndex(function(item,index){
                    return item.id == clearId;
                })
                sys == clearId?this.zancunOptions.addp = "":"";
                this.zancunOptions.del == addOption?this.zancunOptions.del = "":"";

                let hasId = this.optionsBase[this.optionsCopy[addOption].pInx].wageItemList.findIndex(function(item,index){
                    return item.id == clearId;
                })

                if(hasId == -1){
                    this.optionsBase[this.optionsCopy[addOption].pInx].wageItemList.push({id:this.optionsCopy[addOption].id,
                        itemNameCh:this.optionsCopy[addOption].itemNameCh,
                        pInx:this.optionsCopy[addOption].pInx,
                        cInx:this.optionsCopy[addOption].cInx,
                    });
                }
                this.optionsBase[this.optionsCopy[addOption].pInx].wageItemList.sort(this.compare("cInx"));
            }

            this.$set(this.zancunOptions,"copy",this.checked?JSON.parse(JSON.stringify(this.tableData)):JSON.parse(JSON.stringify(this.filteredTableData)));
            this.zancunId = "";
            this.$forceUpdate()
        },
        compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        // nextStep: function(){
        //     this.loading=true
        //     this.$set(this.batchInfo,'id',this.batchId)
        //     let paramMap={
        //         batchInfo: this.batchInfo,
        //         tableData: this.tableData,
        //         fileId: this.fileId
        //     }
        //     uploadStepTwo(paramMap).then(res => {
        //         let rs=res.data
        //         if(rs.code==0){
        //             this.$emit('next',rs.data)
        //             this.loading=false
        //         }else{
        //             this.loading=false
        //         }
        //     }).catch(()=>{
        //         this.loading=false
        //     })
        // },
        // goback: function(){
        //     this.$emit('update:batchInfo', this.batchInfo);
        //     this.$emit('goback')
        // },
        showData(){
            console.log('子组件接收到的值：'+JSON.stringify(this.tableData))
            console.log('子组件接收到的值：'+JSON.stringify(this.options))
            console.log('子组件接收到的值：'+JSON.stringify(this.fileId))
            console.log('子组件接收到的值：'+JSON.stringify(this.batchInfo))
        },
			shouqi(){
				this.tableHeight = 'auto';
			},
      upStep(){
        this.$emit('update:step', 'step1')
        this.$emit('update:disabled',false);//第二步上一步时可编辑
      },
			next(){
        //校验数据封装
        this.loading=true;
        let paramMap = {
          batchInfo:{"salaryTemplateId":this.templateId,"remark":"测试用"},
          batchInfoDetail:this.batchInfoDetail,
          tableData:this.tableData,
          payGroupId:this.payGroupId,
          orgId:this.orgId,
          sheetName:this.sheetNameParam,
          region:this.formInline.region,//服务id
          procName:this.formInline.procName,//服务组合名
          headerRow:this.headerRow,//表头行
          fileId: this.fileId
        }
        if(this.step4Info.batchId){
          paramMap.batchId = this.step4Info.batchId;//如果已有批次信息就传参
          paramMap.operation = this.operation;//添加所选批次操作方式
        }
        uploadStepTwo(paramMap).then(res => {
          this.loading=false;
          let rs=res.data
          if(rs.code==0){
            // console.log('batchId:'+JSON.stringify(rs.data))
            // this.$emit('next',rs.data)
            this.$set(this.step3Info,'total',res.data.data.total);
            this.$set(this.step3Info,'success',res.data.data.success);
            this.$set(this.step3Info,'failure',res.data.data.failure);
            this.$set(this.formInline,'total',res.data.data.total);
            this.$set(this.formInline,'success',res.data.data.success);
            this.$set(this.formInline,'failure',res.data.data.failure);

            if(res.data.data.errorMessages && res.data.data.errorMessages.length>0){
              //this.formInline.status="1";//第三步不显示下一步，有错误信息
              this.$set(this.formInline,'status',"1");
            }else if((res.data.data.warnMessages && res.data.data.warnMessages.length>0)||(res.data.data.tipsMessages && res.data.data.tipsMessages.length>0)){
              //this.formInline.status="2";//第三步显示下一步,但是有警告信息
              this.$set(this.formInline,'status',"2");
            }else{
              //this.formInline.status="3";//第三步显示下一步
              this.$set(this.formInline,'status',"3");
            }

            this.$set(this.step3Info,'errorMessages',res.data.data.errorMessages);
            this.$set(this.step3Info,'warnMessages',res.data.data.warnMessages);
            this.$set(this.step3Info,'tipsMessages',res.data.data.tipsMessages);
            this.$set(this.step3Info,'templateId',this.templateId);
            this.$set(this.step3Info,'batchId',res.data.data.batchId);
            //this.$set(this.step3Info,'isCompute',res.data.data.isCompute);

            this.step4Info.batchId=res.data.data.batchId;//返回批次id
            this.step4Info.templateId=this.templateId;//存储模板信息给第四步用
            this.step4Info.payGroupId=this.payGroupId;//存储模板信息给第四步用
            this.formInline.batchId = res.data.data.batchId;//保存返回批次信息
            this.formInline.payWay = res.data.data.payWay;//保存返回付款方式
            this.formInline.taxTypeList = res.data.data.taxTypeList;//保存返回批次计税类型
            this.formInline.isCompute = res.data.data.isCompute;//保存返回是否计算备用

            this.$emit('update:step3Info',this.step3Info)
            this.$emit('update:step4Info',this.step4Info)
            this.$emit('update:step', 'step3')
            this.$emit('update:formInline',this.formInline)
          }
        })

			}
    }
  };
</script>

<style scoped>
  .step2{
    padding: 0 84px;
    box-sizing: border-box;
  }
   .topFlex .shouqi{
   	font-size:13px;
   	font-family:PingFangSC-Medium,PingFang SC;
   	font-weight:500;
   	color:rgba(114,181,225,1);
		cursor: pointer;
   }
	 .topFlex{
	 	display: flex;
	 	justify-content: space-between;
	 	background: #fff;
	 	padding: 18px 90px 18px 20px
	 }
	 .footer{
	 	display: flex;
	 	margin-top: 16px;
	 }
	 .footer div{
	 	font-size:13px;
	 	font-family:PingFangSC-Medium,PingFang SC;
	 	font-weight:500;
	 	color:rgba(51,51,51,1);
	 	line-height:18px;
	 }
	 .footer p{
	 	font-size:13px;
	 	font-family:PingFangSC-Regular,PingFang SC;
	 	font-weight:400;
	 	color:rgba(51,51,51,1);
	 	line-height:18px;
	 	margin-bottom: 8px;
	 }
   .nodata >>> input::-webkit-input-placeholder {
     color: red;
   }
  .nodata >>> input::-moz-placeholder{
    color: red;
    opacity: 1;
  }
  .nodata >>> input::-ms-input-placeholder{
    color: red;}
</style>


